import React from 'react';
import { Link } from 'react-router-dom';
import { TwitterIcon, GithubIcon, HomeIcon, PlusCircleIcon, LayoutGridIcon as AppsIcon } from 'lucide-react';
export const Footer = () => {
  return <>
      {/* Desktop Footer */}
      <footer className="bg-white border-t border-gray-200 py-8 hidden md:block" data-id="element-118">
        <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-119">
          <div data-id="element-120">
            <h3 className="font-medium text-gray-800 mb-4" data-id="element-121">Company</h3>
            <ul className="space-y-2" data-id="element-122">
              <li data-id="element-123">
                <Link to="/about" className="text-gray-600 hover:text-indigo-600" data-id="element-124">
                  About
                </Link>
              </li>
              <li data-id="element-125">
                <a href="#" className="text-gray-600 hover:text-indigo-600" data-id="element-126">
                  Careers
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-127">
            <h3 className="font-medium text-gray-800 mb-4" data-id="element-128">Resources</h3>
            <ul className="space-y-2" data-id="element-129">
              <li data-id="element-130">
                <a href="#" className="text-gray-600 hover:text-indigo-600" data-id="element-131">
                  Documentation
                </a>
              </li>
              <li data-id="element-132">
                <a href="#" className="text-gray-600 hover:text-indigo-600" data-id="element-133">
                  Help Center
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-134">
            <h3 className="font-medium text-gray-800 mb-4" data-id="element-135">Legal</h3>
            <ul className="space-y-2" data-id="element-136">
              <li className="flex space-x-4" data-id="element-137">
                <a href="#" className="text-gray-600 hover:text-indigo-600" data-id="element-138">
                  Privacy
                </a>
                <span className="text-gray-300" data-id="element-139">|</span>
                <a href="#" className="text-gray-600 hover:text-indigo-600" data-id="element-140">
                  Terms
                </a>
              </li>
              <li data-id="element-141">
                <a href="#" className="text-gray-600 hover:text-indigo-600" data-id="element-142">
                  Security
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-143">
            <h3 className="font-medium text-gray-800 mb-4" data-id="element-144">Connect</h3>
            <div className="flex space-x-4" data-id="element-145">
              <a href="#" className="text-gray-500 hover:text-indigo-600" data-id="element-146">
                <TwitterIcon className="h-5 w-5" data-id="element-147" />
              </a>
              <a href="#" className="text-gray-500 hover:text-indigo-600" data-id="element-148">
                <GithubIcon className="h-5 w-5" data-id="element-149" />
              </a>
            </div>
          </div>
        </div>
      </footer>
      {/* Mobile Navigation Bar */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-2" data-id="element-150">
        <div className="flex justify-around items-center" data-id="element-151">
          <Link to="/" className="flex flex-col items-center p-2" data-id="element-152">
            <HomeIcon className="h-6 w-6 text-gray-500" data-id="element-153" />
            <span className="text-xs text-gray-500" data-id="element-154">Discover</span>
          </Link>
          <Link to="/my-apps" className="flex flex-col items-center p-2" data-id="element-155">
            <AppsIcon className="h-6 w-6 text-gray-500" data-id="element-156" />
            <span className="text-xs text-gray-500" data-id="element-157">My Apps</span>
          </Link>
          <Link to="/create" className="flex flex-col items-center p-2" data-id="element-158">
            <PlusCircleIcon className="h-6 w-6 text-gray-500" data-id="element-159" />
            <span className="text-xs text-gray-500" data-id="element-160">Create</span>
          </Link>
        </div>
      </nav>
    </>;
};